// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__Dih_u","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2zBFB"};